import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "color-wrapper" }
const _hoisted_2 = { class: "selected" }
const _hoisted_3 = { class: "editor" }
const _hoisted_4 = {
  key: 0,
  class: "btn"
}
const _hoisted_5 = {
  key: 1,
  class: "btn"
}
const _hoisted_6 = {
  key: 2,
  class: "btn"
}
const _hoisted_7 = {
  key: 3,
  class: "btn"
}
const _hoisted_8 = {
  key: 4,
  class: "btn"
}
const _hoisted_9 = {
  key: 5,
  class: "checkbox"
}
const _hoisted_10 = {
  key: 6,
  class: "checkbox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_color_card = _resolveComponent("app-color-card")!
  const _component_app_editor_canvas = _resolveComponent("app-editor-canvas")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
          return (_openBlock(), _createBlock(_component_app_color_card, {
            key: card.id,
            card: card,
            "is-selected": _ctx.selectedCard?.id === card?.id,
            onSelected: _ctx.selected
          }, null, 8, ["card", "is-selected", "onSelected"]))
        }), 128))
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_app_editor_canvas, {
          ref: "editorCanvasRef",
          "image-url": _ctx.imageUrl,
          "onUpdate:imageUrl": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageUrl) = $event)),
          segments: _ctx.frameColors
        }, null, 8, ["image-url", "segments"])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["buttons", { isMobile: _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_app_button, {
                raised: "",
                title: "pickPhoto",
                severity: "secondary",
                icon: ['fas', 'sliders'],
                onClick: _ctx.openImageSettingsModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_app_button, {
                raised: "",
                icon: ['fas', 'camera'],
                severity: "secondary",
                title: "takePhoto",
                onClick: _ctx.openCameraModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "download",
                onClick: _ctx.saveToDevice
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_app_button, {
                severity: "warning",
                title: "saveToGallery",
                loading: _ctx.isSaveToGallery,
                onClick: _ctx.saveToGallery
              }, null, 8, ["loading", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_app_button, {
                severity: "info",
                title: "addSign",
                onClick: _ctx.openImageModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.sharedWithCollage,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sharedWithCollage) = $event)),
                label: "shareImageWithCollage"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_AppCheckbox, {
                modelValue: _ctx.rememberChoose,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberChoose) = $event)),
                label: "rememberChoose"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 7,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageSettingsModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'sliders']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('pickPhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openCameraModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'camera']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('takePhoto')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToDevice }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'download']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToGallery }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'images']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('saveToGallery')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fa-pencil-square']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('addSign')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.sharedWithCollage,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sharedWithCollage) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('shareImageWithCollage')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_app_popover_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.rememberChoose,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rememberChoose) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('rememberChoose')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}